import { configureStore } from '@reduxjs/toolkit'
import drawerReducer from './slices/drawerSlice';
import sessionReducer from './slices/sessionSlice';



const store = configureStore({
  reducer: {
    session: sessionReducer,
    drawer: drawerReducer,
  },
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store;
